import { createSlice, prepareAutoBatched } from '@reduxjs/toolkit'
import { useObjSelector } from 'utils'

const initialState = {
	nextId: 0,
	list  : [],
}
const slice = createSlice({
	name: 'alerts',

	initialState,

	reducers: {
		/**
		 * You don't want to use this; check /utils/Alert.js
		 * @private
		 */
		_appendAlert: (state, { payload }) => {
			++state.nextId
			state.list.push(payload)
		},
		/**
		 * You don't want to use this; check /utils/Alert.js
		 * @private
		 */
		_updateAlert: (state, { payload: { id, ...fields } }) => {
			state.list.map(alert => alert.id == id? Object.assign(alert, fields) : alert)
		},
		_removeAlert: {
			prepare: prepareAutoBatched(),
			reducer: (state, { payload: id }) => {
				state.list = state.list.filter(alert => alert.id != id)
			}
		},

		//TODO: probably also unsafe to use elsewhere, since side-effects may still linger
		clearAlerts: () => initialState,
	},
})

export const { _appendAlert, _updateAlert, clearAlerts, _removeAlert } = slice.actions

export const getAlerts = ({ alerts: { list } }) => list
export const useAlerts = () => useObjSelector(getAlerts)
export default slice.reducer
